import React from "react";
import * as aor from "react-admin";
import EmailSender from "./EmailSender";
import PropTypes from "prop-types";

class AddressLink extends React.Component {
    state = { showDialog: false, enabled: false };

    componentDidMount = () => {
        this.setState({
            enabled: this.props.enabled
        });
    };
    handleClick = () => {
        this.setState({ showDialog: true });
    };

    handleClose = () => {
        this.setState({ showDialog: false });
    };

    render() {
        return (
            <div>
                {this.state.enabled ? (
                    <aor.Link to="#" onClick={this.handleClick}>
                        {this.props.record[this.props.source]}
                    </aor.Link>
                ) : (
                    <aor.TextField {...this.props} />
                )}

                <EmailSender
                    showDialog={this.state.showDialog}
                    onCloseDialog={this.handleClose}
                    address={this.props.record[this.props.source]}
                    resource_id={this.props.record.id}
                />
            </div>
        );
    }
}

AddressLink.defaultProps = {
    addLabel: true
};
AddressLink.propTypes = {
    label: PropTypes.string,
    record: PropTypes.object,
    source: PropTypes.string.isRequired
};
export default AddressLink;



// WEBPACK FOOTER //
// ./src/components/AddressLink.js